import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserCog, LogOut } from 'lucide-react';
import { authAPI } from '../services/api';

// Sticky amber bar shown while an admin browses the site as one of the customers
const ImpersonationBanner = () => {
  const navigate = useNavigate();
  const [imp, setImp] = useState(authAPI.impersonation);

  useEffect(() => {
    const refresh = () => setImp(authAPI.impersonation());
    window.addEventListener('cart-updated', refresh);
    window.addEventListener('storage', refresh);
    return () => { window.removeEventListener('cart-updated', refresh); window.removeEventListener('storage', refresh); };
  }, []);

  useEffect(() => {
    if (imp && imp.until && Date.now() > imp.until) { authAPI.stopImpersonation(); setImp(null); }
  }, [imp]);

  if (!imp) return null;
  const stop = () => { authAPI.stopImpersonation(); setImp(null); navigate('/admin?tab=customers'); };
  const c = imp.customer || {};

  return (
    <div className="sticky top-0 z-[60] bg-amber-400 text-amber-950 text-sm shadow-md" data-testid="impersonation-banner" role="status">
      <div className="max-w-7xl mx-auto px-4 py-2 flex flex-wrap items-center gap-x-4 gap-y-1">
        <span className="inline-flex items-center gap-2 font-semibold"><UserCog size={16} /> Mode assistance : vous naviguez en tant que <span data-testid="impersonation-customer">{c.first_name} {c.last_name} ({c.email})</span></span>
        <span className="text-xs text-amber-900/80 hidden sm:inline">Vos actions (panier, commandes) s'appliquent à ce client. Le changement de mot de passe est bloqué.</span>
        <button type="button" onClick={stop} data-testid="impersonation-stop" className="ml-auto inline-flex items-center gap-1.5 rounded-full bg-amber-950 text-amber-50 px-3 py-1.5 text-xs font-semibold hover:bg-black transition-colors"><LogOut size={12} /> Revenir à l'admin</button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
